/**
 * Правила выбора предметной иконки по названию категории.
 *
 * Вынесены отдельно, чтобы иконки и плитки категорий не дублировали правила.
 */

export type CategoryIconKind =
  | 'milk'
  | 'milkWeight'
  | 'drink'
  | 'can'
  | 'sauce'
  | 'icecream'
  | 'pasta'
  | 'spice'
  | 'dumplings'
  | 'cheese'
  | 'sausage'
  | 'sausageSmall'
  | 'sausageBoiled'
  | 'sausageSmoked'
  | 'sausageDry'
  | 'pate'
  | 'delicacy'
  | 'cup'
  | 'candy'
  | 'fish'
  | 'seafoodFrozen'
  | 'snowflake'
  | 'bread'
  | 'apple'
  | 'barcode'
  | 'basket'

/**
 * Порядок правил важен: узкие случаи («молочная продукция вес», «сырокопчёные»)
 * идут раньше широких («молочные», «колбасы»).
 */
const RULES: Array<[RegExp, CategoryIconKind]> = [
  [/штрихкод|штрих-код/, 'barcode'],
  [/заморо.*морепродукт|морепродукт.*заморо|замороженн[а-я]*\s*(рыб|кревет)/, 'seafoodFrozen'],
  [/деликатес/, 'delicacy'],
  [/молочн[а-я]*\s*(продукц|товар)[а-я]*\s*вес|весов/, 'milkWeight'],
  [/сырокопч|сыровял|нарезк/, 'sausageDry'],
  [/копчен|копчён/, 'sausageSmoked'],
  [/вар[её]н[а-я]*\s*колбас/, 'sausageBoiled'],
  [/сардел/, 'sausageSmall'],
  [/сосиск/, 'sausage'],
  [/колбас/, 'sausageSmoked'],
  [/молочн|молоко|кефир|творог|йогурт|ряженк|сметан/, 'milk'],
  [/напит|сок|вода|лимонад|квас|энергетик/, 'drink'],
  [/консерв|туш[её]нк|горошек|кукуруз|оливк|маслин/, 'can'],
  [/соус|майонез|кетчуп|горчиц|аджик/, 'sauce'],
  [/морожен|эскимо|пломбир/, 'icecream'],
  [/макарон|круп|масло|рис|греч|пшено|овсян|мука/, 'pasta'],
  [/специ|приправ|перец|соль|корица/, 'spice'],
  [/полуфабрикат|пельмен|вареник|котлет|блин|голубц/, 'dumplings'],
  [/сыр/, 'cheese'],
  [/паштет|ветчин|жарен|буженин/, 'pate'],
  [/чай|кофе|какао/, 'cup'],
  [/сладост|конфет|шоколад|печень|торт|вафл|зефир|мармелад/, 'candy'],
  [/морепродукт|рыб|кревет|мидии|кальмар|икр/, 'fish'],
  [/заморо|замор|лёд|лед/, 'snowflake'],
  [/хлеб|батон|булк|лаваш|багет/, 'bread'],
  [/овощ|фрукт|яблок|ягод|банан|цитрус/, 'apple']
]

/** Определить иллюстрацию по названию категории. */
export function pickCategoryIcon(name: string): CategoryIconKind {
  const normalized = name.trim().toLowerCase().replace(/ё/g, 'е')
  for (const [pattern, kind] of RULES) {
    if (pattern.test(normalized)) return kind
  }
  return 'basket'
}

/** Все виды иллюстраций — для галереи выбора в админке. */
export const CATEGORY_ICON_KINDS: CategoryIconKind[] = [
  'milk',
  'milkWeight',
  'drink',
  'can',
  'sauce',
  'icecream',
  'pasta',
  'spice',
  'dumplings',
  'cheese',
  'sausage',
  'sausageSmall',
  'sausageBoiled',
  'sausageSmoked',
  'sausageDry',
  'pate',
  'delicacy',
  'cup',
  'candy',
  'fish',
  'seafoodFrozen',
  'snowflake',
  'bread',
  'apple',
  'barcode',
  'basket'
]
